import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import Admin from './admin';
import Login from './admin/components/login';
import * as serviceWorker from './serviceWorker';
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom';
import '../node_modules/jquery/dist/jquery.min.js';
import '../node_modules/popper.js/dist/umd/popper.js';
import '../node_modules/bootstrap/dist/js/bootstrap.min.js';
import '../node_modules/font-awesome/css/font-awesome.min.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import 'bootstrap/dist/css/bootstrap.css';
import { store } from './store/store';
import { Provider } from 'react-redux';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <div>
        {/* Toast component*/}
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />

        <HashRouter basename="/">
          <Switch>
            <Route exact path="/" component={App} />
            {/* <Route path="/" component={Login} /> */}
            {/* <Route path="/admin" component={Admin} /> */}
            <Redirect to="/" />
          </Switch>
        </HashRouter>
      </div>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.unregister();
